module.exports = __webpack_public_path__ + "img/q_54_sor.8f0bd4d3.png";